import { createSlice } from "@reduxjs/toolkit";
import {
  fetchAccounts,
  createAccounts,
  updateAccounts,
  fetchUser,
  fetchRoles,
  fetchAPIUSER,
  fetchAPIPERMISSION,
  fetchAccountsName,
  fetchAccountUser,
  fetchusers,
  createAPIUser,
  createUser,
  updateUser,
  createRoleAccess,
  fetchRoleAccess,
  fetchAPIPermissions,
  createAPIPermission,
  createAPIRoleACCess,
  fetchAPIUSERName,
  fetchAPIRoleAccess,
  fetchUSERName,
  fetchRoleAccessName,
  fetchAllAPIRoleAccess
} from "./customerManagementThunks"; // ⬅️ Simulated thunk

// Initial State
const initialState = {
  accounts: {
    list: [],
    accountNames: [],
    accountUser:[],
    loading: false,
    error: null,
  },
  roles: {
    list: [],
    roleNames: [],
    permissions: {},
    loading: false,
    error: null,
  },
  users: {
    list: [],
    userName:[],
    loading: false,
    error: null,
  },
  apiUser: {
    list: [],
    apiUserNames:[],
    loading: false,
    error: null,
  },
  apiPermission: {
    list: [],
    loading: false,
    error: null,
  },
  apiRoleAccess: {
    list: [],
    allApis:[],
    loading: false,
    error: null,
  },
  activeTab: "accounts",
  filters: {
    search: "",
    pageNo: 0,
    pageSize: 10,
  },
};

// Slice
const customerManagementSlice = createSlice({
  name: "customerManagement",
  initialState,
  reducers: {
    // Accounts Action

    // Roles Actions
    setRolesLoading: (state, action) => {
      state.roles.loading = action.payload;
    },
    setRolesError: (state, action) => {
      state.roles.error = action.payload;
      state.roles.loading = false;
    },
    setRolesList: (state, action) => {
      state.roles.list = action.payload;
      state.roles.loading = false;
      state.roles.error = null;
    },
    addRole: (state, action) => {
      state.roles.list.push(action.payload);
    },
    updateRole: (state, action) => {
      const { id, roleData } = action.payload;
      const index = state.roles.list.findIndex((role) => role.id === id);
      if (index !== -1) {
        state.roles.list[index] = {
          ...state.roles.list[index],
          ...roleData,
        };
      }
    },
    deleteRole: (state, action) => {
      state.roles.list = state.roles.list.filter(
        (role) => role.id !== action.payload
      );
    },
    updatePermissions: (state, action) => {
      state.roles.permissions = action.payload;
    },

    // Users Actions
    setUsersLoading: (state, action) => {
      state.users.loading = action.payload;
    },
    setUsersError: (state, action) => {
      state.users.error = action.payload;
      state.users.loading = false;
    },
    setUsersList: (state, action) => {
      state.users.list = action.payload;
      state.users.loading = false;
      state.users.error = null;
    },
    addUser: (state, action) => {
      state.users.list.push(action.payload);
    },

    // updateUser: (state, action) => {
    //   const { id, userData } = action.payload;
    //   state.users.list = state.users.list.map((user) =>
    //     user.id === id ? { ...user, ...userData } : user
    //   );
    // },

    deleteUser: (state, action) => {
      state.users.list = state.users.list.filter(
        (user) => user.id !== action.payload
      );
    },

    // add api permision

    // General Actions
    setActiveTab: (state, action) => {
      state.activeTab = action.payload;
    },
    updateFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    resetFilters: (state) => {
      state.filters = {
        search: "",
        pageNo: 0,
        pageSize: 10,
      };
    },
  },

  extraReducers: (builder) => {
    builder
      // fetchAccounts
      .addCase(fetchAccounts.pending, (state) => {
        state.accounts.loading = true;
        state.accounts.error = null;
      })
      .addCase(fetchAccounts.fulfilled, (state, action) => {
        state.accounts.list = action.payload;
        state.accounts.loading = false;
      })
      .addCase(fetchAccounts.rejected, (state, action) => {
        state.accounts.loading = false;
        state.accounts.error =
          action.error.message || "Failed to load accounts";
      })

      //for Fetch Account Name
      .addCase(fetchAccountsName.pending, (state) => {
        state.accounts.loading = true;
        state.accounts.error = null;
      })
      .addCase(fetchAccountsName.fulfilled, (state, action) => {
        state.accounts.accountNames = action.payload; // ✅ Only update name list
        state.accounts.loading = false;
      })
      .addCase(fetchAccountsName.rejected, (state, action) => {
        state.accounts.loading = false;
        state.accounts.error =
          action.error.message || "Failed to load accounts Name";
      })

      // Handle createAccounts
      .addCase(createAccounts.pending, (state) => {
        state.accounts.loading = true;
        state.accounts.error = null;
      })
      .addCase(createAccounts.fulfilled, (state) => {
        state.accounts.loading = false;
      })
      .addCase(createAccounts.rejected, (state, action) => {
        state.accounts.loading = false;
        state.accounts.error = action.payload || "Failed to create account";
      })

      // Handle updateAccount
      .addCase(updateAccounts.pending, (state) => {
        state.accounts.loading = true;
        state.accounts.error = null;
      })
      .addCase(updateAccounts.fulfilled, (state) => {
        state.accounts.loading = false;
      })
      .addCase(updateAccounts.rejected, (state, action) => {
        state.accounts.loading = false;
        state.accounts.error = action.payload || "Failed to update account";
      })

      //for fetch account data for adding user
      .addCase(fetchAccountUser.pending, (state) => {
        state.accounts.loading = true;
        state.accounts.error = null;
      })
      .addCase(fetchAccountUser.fulfilled, (state, action) => {
        state.accounts.accountUser = action.payload;
        state.accounts.loading = false;
      })
      .addCase(fetchAccountUser.rejected, (state, action) => {
        state.accounts.loading = false;
        state.accounts.error = action.payload || "Failed to update account";
      })

     
      //fetch user
      .addCase(fetchusers.pending, (state) => {
        state.users.loading = true;
        state.users.error = null;
      })
      .addCase(fetchusers.fulfilled, (state, action) => {
        state.users.list = action.payload;
        state.users.loading = false;
      })
      .addCase(fetchusers.rejected, (state, action) => {
        state.users.loading = false;
        state.users.error = action.error.message || "Failed to Load User ";
      })

       //fetch  userName
      .addCase(fetchUSERName.pending, (state) => {
        state.users.loading = true;
        state.users.error = null;
      })
      .addCase(fetchUSERName.fulfilled, (state, action) => {
        state.users.userName = action.payload; // ✅ Only update name list
        state.users.loading = false;
      })
      .addCase(fetchUSERName.rejected, (state, action) => {
        state.users.loading = false;
        state.users.error =
          action.error.message || "Failed to load accounts Name";
      })

        // Handle createUser
      .addCase(createUser.pending, (state) => {
        state.users.loading = true;
        state.users.error = null;
      })
      .addCase(createUser.fulfilled, (state) => {
        state.users.loading = false;
      })
      .addCase(createUser.rejected, (state, action) => {
        state.users.loading = false;
        state.users.error = action.payload || "Failed to create account";
      })

      //updateUser

      .addCase(updateUser.pending, (state) => {
        state.users.loading = true;
        state.users.error = null;
      })
      .addCase(updateUser.fulfilled, (state) => {
        state.users.loading = false;
      })
      .addCase(updateUser.rejected, (state, action) => {
        state.users.loading = false;
        state.users.error = action.payload || "Failed to update account";
      })

   

      //fetch Api user
      .addCase(fetchAPIUSER.pending, (state) => {
        state.apiUser.loading = true;
      })
      .addCase(fetchAPIUSER.fulfilled, (state, action) => {
        state.apiUser.list = action.payload;
        state.apiUser.loading = false;
      })
      .addCase(fetchAPIUSER.rejected, (state, action) => {
        state.apiUser.loading = false;
        state.apiUser.error = action.error.message;
      })



        //fetch Api userName
      .addCase(fetchAPIUSERName.pending, (state) => {
        state.apiUser.loading = true;
        state.apiUser.error = null;
      })
      .addCase(fetchAPIUSERName.fulfilled, (state, action) => {
        state.apiUser.apiUserNames = action.payload; // ✅ Only update name list
        state.apiUser.loading = false;
      })
      .addCase(fetchAPIUSERName.rejected, (state, action) => {
        state.apiUser.loading = false;
        state.apiUser.error =
          action.error.message || "Failed to load accounts Name";
      })

    
      

     //create API User
      .addCase(createAPIUser.pending, (state) => {
        state.apiUser.loading = true;
        state.apiUser.error = null;
      })
      .addCase(createAPIUser.fulfilled, (state, action) => {
        state.apiUser.loading = false;
        state.apiUser.error = null;
        // Optionally add the created user to the list if the API returns the created user data
        // Uncomment the line below if your API returns the created user in the response
        // state.apiUser.list.push(action.payload);
      })
      .addCase(createAPIUser.rejected, (state, action) => {
        state.apiUser.loading = false;
        state.apiUser.error = action.payload || "Failed to create API User";
      })


      //create Account Role&Access
       .addCase(createRoleAccess.pending, (state) => {
        state.roles.loading = true;
        state.roles.error = null;
      })
      .addCase(createRoleAccess.fulfilled, (state, action) => {
        state.roles.loading = false;
        state.roles.error = null;
      })
      .addCase(createRoleAccess.rejected, (state, action) => {
        state.roles.loading = false;
        state.roles.error = action.payload || "Failed to create Role And Access";
      })


   //fetch Roles
      .addCase(fetchRoleAccess.pending, (state) => {
        state.roles.loading = true;
        state.roles.error = null;
      })
      .addCase(fetchRoleAccess.fulfilled, (state, action) => {
        state.roles.list = action.payload;
        state.roles.loading = false;
      })
      .addCase(fetchRoleAccess.rejected, (state, action) => {
        state.roles.loading = false;
        state.roles.error =
          action.error.message || "Failed to fetch Roles & Access";
      })
      
      //fetch role name 
      .addCase(fetchRoleAccessName.pending, (state) => {
        state.roles.loading = true;
        state.roles.error = null;
      })
      .addCase(fetchRoleAccessName.fulfilled, (state, action) => {
        state.roles.roleNames = action.payload; 
        state.roles.loading = false;
      })
      .addCase(fetchRoleAccessName.rejected, (state, action) => {
        state.roles.loading = false;
        state.roles.error =
          action.error.message || "Failed to load Role Name";
      })
      //fetch Api Permission
      .addCase(fetchAPIPermissions.pending, (state) => {
        state.apiPermission.loading = true;
        state.apiPermission.error = null;
      })
      .addCase(fetchAPIPermissions.fulfilled, (state, action) => {
        state.apiPermission.list = action.payload;
        state.apiPermission.loading = false;
      })
      .addCase(fetchAPIPermissions.rejected, (state, action) => {
        state.apiPermission.loading = false;
        state.apiPermission.error =
          action.error.message || "Failed to fetch Api User";
      })


       //create Api Permission
       .addCase(createAPIPermission.pending, (state) => {
        state.apiPermission.loading = true;
        state.apiPermission.error = null;
      })
      .addCase(createAPIPermission.fulfilled, (state, action) => {
        state.apiPermission.loading = false;
        state.apiPermission.error = null;
      })
      .addCase(createAPIPermission.rejected, (state, action) => {
        state.apiPermission.loading = false;
        state.apiPermission.error = action.payload || "Failed to create ";
      })

      // create apiRoleAccess
      .addCase(createAPIRoleACCess.pending, (state) => {
        state.apiRoleAccess.loading = true;
        state.apiRoleAccess.error = null;
      })
      .addCase(createAPIRoleACCess.fulfilled, (state, action) => {
        state.apiRoleAccess.loading = false;
        state.apiRoleAccess.error = null;
      })
      .addCase(createAPIRoleACCess.rejected, (state, action) => {
        state.apiRoleAccess.loading = false;
        state.apiRoleAccess.error = action.payload || "Failed to create API Role And Access";
      })

       //fetch Api userName
      .addCase(fetchAPIRoleAccess.pending, (state) => {
        state.apiRoleAccess.loading = true;
        state.apiRoleAccess.error = null;
      })
      .addCase(fetchAPIRoleAccess.fulfilled, (state, action) => {
        state.apiRoleAccess.list = action.payload; 
        state.apiRoleAccess.loading = false;
      })
      .addCase(fetchAPIRoleAccess.rejected, (state, action) => {
        state.apiRoleAccess.loading = false;
        state.apiRoleAccess.error =
          action.error.message || "Failed to load accounts Name";
      })

      // for fetching all apis
      .addCase(fetchAllAPIRoleAccess.pending, (state) => {
        state.apiRoleAccess.loading = true;
        state.apiRoleAccess.error = null;
      })
      .addCase(fetchAllAPIRoleAccess.fulfilled, (state, action) => {
        state.apiRoleAccess.allApis = action.payload; 
        state.apiRoleAccess.loading = false;
      })
      .addCase(fetchAllAPIRoleAccess.rejected, (state, action) => {
        state.apiRoleAccess.loading = false;
        state.apiRoleAccess.error =
          action.error.message || "Failed to load accounts Name";
      })
  },
});

// Export actions
export const {
  setAccountsLoading,
  setAccountsError,
  setAccountsList,
  addAccount,
  updateAccount,
  deleteAccount,
  setRolesLoading,
  setRolesError,
  setRolesList,
  addRole,
  updateRole,
  deleteRole,
  updatePermissions,
  setUsersLoading,
  setUsersError,
  setUsersList,
  addUser,
  deleteUser,
  setActiveTab,
  updateFilters,
  resetFilters,
} = customerManagementSlice.actions;

// Export reducer
export default customerManagementSlice.reducer;
